import { FC } from "react";

const Bus: FC = () => {
    return (
        <>
            <div className="fs-16 fw-700 text-black">Bus</div>
            <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M15 3.125C10 3.125 5 3.75 5 8.125V20C5 21.1875 5.475 22.2625 6.25 23.05V25.625C6.25 26.3125 6.8125 26.875 7.5 26.875H8.75C9.4375 26.875 10 26.3125 10 25.625V24.375H20V25.625C20 26.3125 20.5625 26.875 21.25 26.875H22.5C23.1875 26.875 23.75 26.3125 23.75 25.625V23.05C24.525 22.2625 25 21.1875 25 20V8.125C25 3.75 20.525 3.125 15 3.125ZM15 5.625C19.6375 5.625 21.4125 6.2 22.0875 6.875H8.0375C8.7875 6.225 10.6 5.625 15 5.625ZM22.5 19.375C22.5 20.75 21.375 21.875 20 21.875H10C8.625 21.875 7.5 20.75 7.5 19.375V15.625H22.5V19.375ZM22.5 13.125H7.5V9.375H22.5V13.125Z"
                fill="black"
                />
                <path
                d="M10.625 20.625C11.6605 20.625 12.5 19.7855 12.5 18.75C12.5 17.7145 11.6605 16.875 10.625 16.875C9.58947 16.875 8.75 17.7145 8.75 18.75C8.75 19.7855 9.58947 20.625 10.625 20.625Z"
                fill="black"
                />
                <path
                d="M19.375 20.625C20.4105 20.625 21.25 19.7855 21.25 18.75C21.25 17.7145 20.4105 16.875 19.375 16.875C18.3395 16.875 17.5 17.7145 17.5 18.75C17.5 19.7855 18.3395 20.625 19.375 20.625Z"
                fill="black"
                />
            </svg>
        </>
    )
}

export default Bus;